<template>
  <el-dialog
    class="app-manage-push-dialog"
    :visible.sync="selfDialogVisible"
    :before-close="beforeClose"
    :custom-class="sitirDialogFixed"
  >
    <el-container class="nav-page-plugin-select-org">
      <el-header class="nav-page-plugin-select-org__header" height="44px">
        <el-row class="nav-page-plugin-select-org-top">
          <el-col class="nav-page-plugin-select-org-search">
            <el-input
              size="small"
              placeholder="请输入内容"
              v-model="input3"
              class="input-with-select"
            >
              <i class="el-icon-search" slot="append">查询</i>
            </el-input>
          </el-col>
        </el-row>
      </el-header>
      <el-main
        class="nav-page-plugin-select-org__main"
        ref="sitirPureItemFormMain"
      >
        <el-tree
          class="filter-tree"
          :data="selectOrgTree"
          :props="{
            children: 'children',
            label: 'orgName',
          }"
          @node-click="selectOrg"
          :expand-on-click-node="false"
          :check-on-click-node="true"
          accordion
          default-expand-all
          ref="tree"
        ></el-tree>
      </el-main>
    </el-container>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'nav-page-plugin-select-org',
  props: {
    dialogVisible: {
      type: Boolean,
    },
    rootOrg: {
      type: Object,
    },
    orgList: {
      type: Array,
    },
  },
  computed: {
    ...mapState(['selectOrgTree']),
    selfDialogVisible: {
      get() {
        return this.dialogVisible
      },
      set() {},
    },
    selfOrgList: {
      get() {
        const commonOrg = [
          {
            orgName: '常用组织',
            id: null,
            children: [
              {
                orgName: '常用组织1',
              },
              {
                orgName: '常用组织2',
              },
              {
                orgName: '常用组织3',
              },
            ],
          },
        ]
        const orgin = [
          {
            orgName: '当前平台',
            id: this.rootOrg.id,
            // children: commonOrg.concat(this.orgList),
            children: this.orgList,
          },
        ]
        return orgin
      },
    },
  },
  data() {
    return {
      activeTopOrg: '',
      input3: null,
      maxTableHeight: 300,
      sitirDialogFixed: 'nav-page-plugin-select-org-dialog--fixed',
    }
  },
  mounted() {
    addEventListener('resize', this.resizeGetHeight, false)
  },
  methods: {
    ...mapMutations(['updateNavPage']),
    // 选择组织
    selectOrg(item, node, com) {
      const data = {
        flag: false,
        org: {
          orgName: item.orgName,
          id: item.id,
          currentTopOrg: this.activeTopOrg,
        },
      }
      this.updateNavPage(data)
      this.$emit('updateDialogVisible', {
        flag: false,
        org: {
          orgName: item.orgName,
          id: item.id,
          currentTopOrg: this.activeTopOrg,
        },
      })
    },
    // 窗口变化调用函数
    resizeGetHeight() {
      this.$nextTick(() => {
        if (!this.$refs.sitirPureItemFormMain) {
          return false
        }
        // 设置表格最大高度
        this.maxTableHeight =
          this.$refs.sitirPureItemFormMain.$el.clientHeight - 120
      })
    },
    beforeClose(done) {
      this.$emit('updateDialogVisible', {
        flag: false,
      })
      done()
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/global.scss';
@import 'assets/scss/color.scss';

:deep(.nav-page-plugin-select-org-dialog--fixed) {
  .el-dialog__header {
    padding: 0;
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  $width: 420px;
  margin-top: 0 !important;
  @include sitir-dialog--fixed($width, 5%, 5%);
  @media (min-width: 978px) {
    @include sitir-dialog--fixed(420px, 5%, 5%);
  }
}
.input-with-select {
  &.el-input-group {
    max-width: 300px;
  }
  .el-input-group__append {
    border: 1px solid #8ac3ff;
    border-left: none;
    padding: 0 12px;
    cursor: pointer;
    color: white;
    background: #2b91fa;
    &:hover {
      background-color: #0783ff;
    }
  }
  .el-input__inner {
    color: #d7eaff;
    border: 1px solid #8ac3ff;
    background: transparent;
    border-right: none;
    padding: 0 12px;
    &::-webkit-input-placeholder {
      color: #bcdbff;
    }
  }
}

.nav-page-plugin-select-org {
  height: 100%;
  &__header {
    position: relative;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background: #fff;
    color: $color-word-white;
    border-bottom: 1px solid #e3e3e3;
    &--inner {
      display: flex;
      flex-flow: row nowrap;
      .el-col {
        flex: 1;
      }
    }
    .el-breadcrumb {
      &__inner,
      &__separator {
        color: $color-word-white !important;
      }
    }
  }
  &__name {
    float: right;
    padding-right: 30px;
  }
  &__main {
    border: initial !important;
    height: calc(100% - 60px);
    padding: 20px;
    overflow-y: auto !important;
    :deep(.el-tree-node__content) {
      &:hover {
        background: #f1f5fe;
      }
    }
  }
  &__wrapper {
    display: flex;
    flex-flow: row nowrap;
    height: 100%;
    .el-divider {
      height: 100%;
      background: #6c6c6c;
    }
  }
  &__topOrg,
  &__secondOrg {
    flex: 1;
  }
  &-top,
  &-bottom {
    display: flex;
    flex-flow: row nowrap;
  }
  &-top {
    position: absolute;
    transform: translate(0, -50%);
    top: 50%;
  }
  &-bottom {
    height: 44px;
  }
  &-func,
  &-search,
  &-statistic,
  &-page {
    flex: 1;
  }
  &__func {
    display: inline-block;
    cursor: pointer;
    & + & {
      margin: 0 10px;
    }
  }
  &-statistic {
    height: 44px;
  }
  &-dialog--fixed {
    font-size: 20px;
  }
  &-dialog {
    &--fixed {
    }
  }
  img {
    width: 36px;
    display: inline-block;
  }
  &__select-img {
    border: 1px solid rgb(0, 162, 255);
    background: rgb(139, 209, 255);
    border-radius: 3px;
  }
}
</style>
